module.exports = __webpack_public_path__ + "img/maintenance_orange.33cb2da6.svg";